import { Box, Slider, Typography } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import React from 'react';

const SALARY_MARKS = Array.from({ length: 26 }, (_, i) => {
  const v = i * 2;
  return {
    value: v * 10000,
    label: `${v * 10}k`
  };
});

const SalarySelect = ({ label, ...props }) => (
  <>
    <Typography variant="subtitle1">{label}</Typography>
    <Box px={2}>
      <Slider marks={SALARY_MARKS} max={500000} min={0} step={10000} {...props} />
    </Box>
  </>
);

SalarySelect.defaultProps = {
  label: ''
};

SalarySelect.propTypes = {
  label: PropTypes.string
};

export default SalarySelect;
